var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2456 16.6626C12.2456 17.3299 12.786 17.8703 13.4532 17.8703H14.6609L17.7685 20.9779C17.8863 21.0957 18.0771 21.0965 18.1956 20.9779C18.2511 20.9224 18.283 20.8472 18.2846 20.7682V17.8695H26.7388C27.4061 17.8695 27.9464 17.3292 27.9464 16.6619V8.20764C27.9464 7.54036 27.4061 7 26.7388 7H13.454C12.7867 7 12.2464 7.54036 12.2464 8.20764V16.6619L12.2456 16.6626Z",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8687 10.624H24.2849",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8687 14.2471H24.2849",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7168 23.0031C7.7168 24.5041 8.93356 25.7201 10.4338 25.7201C11.934 25.7201 13.1508 24.5034 13.1508 23.0031C13.1508 21.5029 11.934 20.2861 10.4338 20.2861C8.93356 20.2861 7.7168 21.5029 7.7168 23.0031Z",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2614 28.4622C12.0133 26.3418 8.47168 26.4459 6.35204 28.694C5.6992 29.3864 5.23408 30.233 5 31.1556H12.2466",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6245 23.0031C24.6245 24.5041 25.8413 25.7201 27.3415 25.7201C28.8418 25.7201 30.0585 24.5034 30.0585 23.0031C30.0585 21.5029 28.8418 20.2861 27.3415 20.2861C25.8413 20.2861 24.6245 21.5029 24.6245 23.0031Z",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5151 28.4622C25.7632 26.3418 29.3048 26.4459 31.4245 28.694C32.0773 29.3864 32.5424 30.233 32.7765 31.1556H25.5299",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1709 26.6262C16.1709 28.1272 17.3877 29.3432 18.8879 29.3432C20.3881 29.3432 21.6049 28.1264 21.6049 26.6262C21.6049 25.1259 20.3881 23.9092 18.8879 23.9092C17.3877 23.9092 16.1709 25.1259 16.1709 26.6262Z",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3229 34.7787C23.5575 31.7775 20.5039 29.9641 17.5026 30.7302C15.5137 31.2371 13.961 32.7905 13.4541 34.7787H24.3236H24.3229Z",
    stroke: "#4F4296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunications);
export default __webpack_public_path__ + "static/media/communications.731d875f59314a1e2795f8da31a1ebe0.svg";
export { ForwardRef as ReactComponent };